import { render, staticRenderFns } from "./DocSubtypeManagement.vue?vue&type=template&id=69f31285"
import script from "./DocSubtypeManagement.vue?vue&type=script&lang=js"
export * from "./DocSubtypeManagement.vue?vue&type=script&lang=js"
import style0 from "./DocSubtypeManagement.vue?vue&type=style&index=0&id=69f31285&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports